<template>
  <div>
    <protocol-header v-if="protocol"
                     :protocol="protocol"
                     :task="task"></protocol-header>
    
    <div class="row">
      <div class="col-12">
        <form id="frm-evaluation"
              ref="form"
              accept-charset="UTF-8"
              class="card"
              method="GET"
              onsubmit="return false">
          <div class="card-header">
            <h1 class="card-title mb-0">{{ task.classification.title }}</h1>
          </div>
          
          <div class="card-body">
            <div class="form-group">
              <p class="alert alert-danger">Validar la información del financiamiento e incluir
                                                                 convenio autorizado.</p>
            </div>
            
            <div class="financing-information">
              <protocol-financing :protocol="protocol"></protocol-financing>
            </div>
            
            <div class="mt-4">
              <div class="form-group">
                <p>Periodo de desarrollo: <strong>
                  {{ formatDate(protocol.start_date) }} a {{ formatDate(protocol.end_date) }}</strong></p>
              </div>
              <div class="form-group" v-if="protocol.real_start_date !== null || protocol.real_end_date !== null">
                <p>Periodo real de desarrollo: <strong>
                  {{ formatDate(protocol.real_start_date) }} a {{ formatDate(protocol.real_end_date) }}</strong></p>
              </div>
              
              <div class="form-row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="d-block font-weight-normal"
                           for="real_start_date">Fecha real de inicio:
                      <abbr style="text-decoration: none;"
                            title="Campo obligatorio">*</abbr>
                    </label>
                    
                    <input type="date"
                           name="real_start_date"
                           id="real_start_date"
                           class="form-control"
                           placeholder="DD/MM/AAAA"
                           v-model="real_start_date"/>
                  </div>
                </div>
                
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="d-block font-weight-normal"
                           for="real_end_date">Fecha real de término:
                      <abbr style="text-decoration: none;"
                            title="Campo obligatorio">*</abbr>
                    </label>
                    
                    <input type="date"
                           name="real_end_date"
                           id="real_end_date"
                           class="form-control"
                           placeholder="DD/MM/AAAA"
                           v-model="real_end_date"/>
                  </div>
                </div>
              </div>
              
              <div class="form-group">
                <button type="button"
                        class="btn btn-primary btn-lg"
                        @click="confirmRequestDevelopment">Solicitar desarrollo de protocolo
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    
    <portal to="extraModals">
      <ok-cancel-dialog title="Enviar protocolo a desarrollo"
                        id="send-protocol-modal"
                        ref="send-protocol-modal"
                        content="<p>El protocolo se enviará a desarrollo</p>"
                        ok-button-text="Confirmar"
                        :ok-callback="requestDevelopment"></ok-cancel-dialog>
    </portal>
  </div>
</template>
<script>
  import ProtocolHeader from './ProtocolHeader'
  import autosize from 'autosize'
  import 'jquery-validation'
  import moment from 'moment'
  import { mapActions } from 'vuex'
  import { AlertManager } from '../utils/AlertManager'
  import OkCancelDialog from '../ui/OkCancelDialog'
  import ProtocolFinancing from './ProtocolFinancing'
  import 'flatpickr'
  import 'flatpickr/dist/flatpickr.min.css'
  import { Spanish } from 'flatpickr/dist/l10n/es'
  
  export default {
    name: 'ProtocolDevelopmentRequest',
    components: {
      ProtocolFinancing,
      ProtocolHeader,
      OkCancelDialog,
    },
    props: {
      user: Object,
      protocol: Object,
      task: Object,
    },
    data () {
      return {
        real_start_date: null,
        real_end_date: null,
      }
    },
    methods: {
      ...mapActions({
        sendProtocolToDevelopment: 'protocols/requestProtocolDevelopment',
      }),
      
      /**
       *
       * @returns {boolean}
       */
      confirmRequestDevelopment () {
        if (!$(this.$refs.form).valid()) {
          return false
        }
        
        $('#send-protocol-modal').modal()
      },
      /**
       *
       * @returns {Promise<boolean>}
       */
      async requestDevelopment () {
        const {
                real_start_date,
                real_end_date,
                protocol,
              } = this
  
        const response = await this.sendProtocolToDevelopment({
          protocol,
          real_start_date: moment(real_start_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
          real_end_date: moment(real_end_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        })
        
        const {
                error,
                status,
                message,
              } = response.data.data
        
        if (status === 'error') {
          AlertManager.error(error)
          
          return false
        }
        
        AlertManager.success(message)
        
        this.$emit('close-task')
      },
      formatDate (date) {
        return moment(date).format('DD/MM/YYYY')
      },
    },
    async mounted () {
      const vm = this
      
      autosize(document.getElementById('comments'))
      
      const minDate = moment(this.task.min_date)
      
      const $startDate = $('#real_start_date')
      const $endDate = $('#real_end_date')
  
      $startDate.flatpickr({
        disableMobile: false,
        dateFormat: 'd/m/Y',
        locale: Spanish,
        minDate: minDate.format('DD/MM/YYYY'),
        onChange (dates, dateStr, instance) {
          const date = moment(dates[0]).add(1, 'd').format('DD/MM/YYYY')
          vm.endDate.set('minDate', date)
        },
      })
  
      $endDate.flatpickr({
        disableMobile: false,
        dateFormat: 'd/m/Y',
        locale: Spanish,
        minDate: minDate.format('DD/MM/YYYY'),
      })
  
      this.starDate = $startDate.get(0)._flatpickr
      this.endDate  = $endDate.get(0)._flatpickr
  
      $.validator.addMethod('after', function (value, element, param) {
        const start = moment($(param).val(), 'DD/MM/YYYY').format('YYYY-MM-DD')
        const end   = moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD')
    
        return $(param).val() !== '' && value !== '' && moment(end).isAfter(start)
      }, 'La fecha de término debe ser posterior a la fecha de inicio.')
      
      $(this.$refs.form).validate({
        highlight: function (element, errorClass, validClass) {
          $(element).addClass('is-invalid')
        },
        unhighlight: function (element, errorClass, validClass) {
          $(element).removeClass('is-invalid')
        },
        errorPlacement: function (label, element) {
          label.addClass('invalid-feedback')
          label.insertAfter(element)
        },
        rules: {
          real_start_date: {
            required: true,
          },
          real_end_date: {
            required: true,
            after: '#real_start_date',
          },
        },
        messages: {
          real_start_date: {
            required: 'Seleccione la fecha real de inicio.',
          },
          real_end_date: {
            required: 'Seleccione la fecha real de término.',
          },
        },
      })
    },
  }
</script>
